import { PaymentDetails } from '~/types';
import axios, { ResponseType, auth } from './axios';

export const getPaymentDetails = (params: any): ResponseType<any> => {
  return axios.get('/staticPaymentDetails', { params });
};

export const getPaymentDetailById = (id: string): ResponseType<any> => {
  return axios.get(`/staticPaymentDetails/${id}`);
};

export const deletePaymentDetails = (id: string): ResponseType<any> => {
  return axios.delete(`/staticPaymentDetails/${id}`);
};

export const getPaymentDetailsQR = (id: string) => (): ResponseType<any> => {
  if (!id) return Promise.resolve() as any;
  return axios.get(`/staticPaymentDetails/${id}/qrcode`, { responseType: 'blob' });
};

export const createPaymentDetails = (body: PaymentDetails): ResponseType<PaymentDetails> => {
  const { amount, ...rest } = body;
  let resultAmount;
  if (amount.currency && typeof amount.value === 'number') {
    resultAmount = amount;
  }
  return axios.post(`/staticPaymentDetails`, {
    ...rest,
    amount: resultAmount,
    businessId: auth.getProfile(),
    operationType: 'PURCHASE',
  });
};

export const updatePaymentDetails = ({
  id,
  body,
}: {
  id: string;
  body: PaymentDetails;
}): ResponseType<PaymentDetails> => {
  const result = { ...body };
  if (typeof result.amount.value !== 'number') {
    delete result.amount;
  }
  return axios.put(`/staticPaymentDetails/${id}`, result);
};
